import React, {useContext} from "react";
import {LoadingAnimation} from "../../Service/ResourceAdapter";
import {WindowContext} from "../../Service/Context/WindowContext";
import QuestionList from "./QuestionList";
import BookitupEntityPreview from "../../Atoms/BookitupEntityPreview";

export default ({formSubmission, questionBundles, values, handleChange, language}) => {
    const {windowWidth} = useContext(WindowContext);

    if (!questionBundles) {
        return <LoadingAnimation />
    }



    let styles = {
        container: {
          marginTop: 20,
          marginBottom: 20,
        },
        firstColumn: {
            width: 100,
            display: "flex",
            justifyContent: "center",
        },
        textColumn: {
            flex: 1,
        },
        priceColumn: {
            width: windowWidth < 800 ? 80 : (windowWidth > 1100 ? 150 : 100),
            textAlign: "right"
        },
        previewHeader: {
            display: "flex",
            alignItems: "flex-start",
            gap: 16,
            minHeight: 64,
        },
        previewText: {
            flex: 1,
            minWidth: 0,
        },
        previewDescription: {
            color: "gray",
            fontSize: 12,
            margin: "4px 0 0",
        }
    };

    return (
        <div style={styles.container}>
            {questionBundles.map((bundle, index) => {
                const fullWidthImage = bundle.imageLayout === "FULL_WIDTH";
                const title = <div style={{fontSize: 20}} dangerouslySetInnerHTML={{__html: bundle.title}}/>;
                const description = (bundle.description && bundle.description !== "") && (
                    <p
                        style={fullWidthImage || !bundle.image
                            ? {color: "gray", fontSize: 12}
                            : styles.previewDescription}
                        dangerouslySetInnerHTML={{__html: bundle.description}}
                    />
                );

                return <div key={index}>
                            {bundle.image && !fullWidthImage && (
                                <div style={styles.previewHeader}>
                                    <BookitupEntityPreview
                                        {...bundle.image}
                                        compact
                                    />
                                    <div style={styles.previewText}>
                                        {title}
                                        {description}
                                    </div>
                                </div>
                            )}
                            {bundle.image && fullWidthImage && (
                                <BookitupEntityPreview
                                    {...bundle.image}
                                    fullWidth
                                />
                            )}
                            {(!bundle.image || fullWidthImage) && title}
                            {(!bundle.image || fullWidthImage) && description}
                        
                        <QuestionList questions={bundle.questions} key={index} formSubmission={formSubmission} values={values} handleChange={handleChange} columnStyles={styles} language={language} />
                    </div>
            })}
        </div>

    )
}
